export const FilterIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 5C13.75 4.65482 14.0298 4.375 14.375 4.375H17.5C17.8452 4.375 18.125 4.65482 18.125 5C18.125 5.34518 17.8452 5.625 17.5 5.625H14.375C14.0298 5.625 13.75 5.34518 13.75 5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.875 5C1.875 4.65482 2.15482 4.375 2.5 4.375H11.875C12.2202 4.375 12.5 4.65482 12.5 5C12.5 5.34518 12.2202 5.625 11.875 5.625H2.5C2.15482 5.625 1.875 5.34518 1.875 5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 15C13.75 14.6548 14.0298 14.375 14.375 14.375H17.5C17.8452 14.375 18.125 14.6548 18.125 15C18.125 15.3452 17.8452 15.625 17.5 15.625H14.375C14.0298 15.625 13.75 15.3452 13.75 15Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.875 15C1.875 14.6548 2.15482 14.375 2.5 14.375H11.875C12.2202 14.375 12.5 14.6548 12.5 15C12.5 15.3452 12.2202 15.625 11.875 15.625H2.5C2.15482 15.625 1.875 15.3452 1.875 15Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 10C7.5 9.65482 7.77982 9.375 8.125 9.375H17.5C17.8452 9.375 18.125 9.65482 18.125 10C18.125 10.3452 17.8452 10.625 17.5 10.625H8.125C7.77982 10.625 7.5 10.3452 7.5 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.875 10C1.875 9.65482 2.15482 9.375 2.5 9.375H5.625C5.97018 9.375 6.25 9.65482 6.25 10C6.25 10.3452 5.97018 10.625 5.625 10.625H2.5C2.15482 10.625 1.875 10.3452 1.875 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.125 4.375C12.7798 4.375 12.5 4.65482 12.5 5C12.5 5.34518 12.7798 5.625 13.125 5.625C13.4702 5.625 13.75 5.34518 13.75 5C13.75 4.65482 13.4702 4.375 13.125 4.375ZM11.25 5C11.25 3.96447 12.0895 3.125 13.125 3.125C14.1605 3.125 15 3.96447 15 5C15 6.03553 14.1605 6.875 13.125 6.875C12.0895 6.875 11.25 6.03553 11.25 5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.875 9.375C6.52982 9.375 6.25 9.65482 6.25 10C6.25 10.3452 6.52982 10.625 6.875 10.625C7.22018 10.625 7.5 10.3452 7.5 10C7.5 9.65482 7.22018 9.375 6.875 9.375ZM5 10C5 8.96447 5.83947 8.125 6.875 8.125C7.91053 8.125 8.75 8.96447 8.75 10C8.75 11.0355 7.91053 11.875 6.875 11.875C5.83947 11.875 5 11.0355 5 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.125 14.375C12.7798 14.375 12.5 14.6548 12.5 15C12.5 15.3452 12.7798 15.625 13.125 15.625C13.4702 15.625 13.75 15.3452 13.75 15C13.75 14.6548 13.4702 14.375 13.125 14.375ZM11.25 15C11.25 13.9645 12.0895 13.125 13.125 13.125C14.1605 13.125 15 13.9645 15 15C15 16.0355 14.1605 16.875 13.125 16.875C12.0895 16.875 11.25 16.0355 11.25 15Z"
      fill="currentColor"
    />
  </svg>
);
